import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from './loader.styles';
import { colors } from '~/themes/variables';
const LoaderWrap = styled.div `
  ${styles}
`;
const Loader = ({ size = 48, color = colors.purpleButton, thickness = 3, speed = 1 }) => {
    return (_jsx(LoaderWrap, { size: size, color: color, thickness: thickness, speed: speed, children: _jsx("span", { className: "global-loader" }) }));
};
Loader.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
    thickness: PropTypes.number,
    speed: PropTypes.number,
};
export default Loader;
